import { render, staticRenderFns } from "./DocumentAdditionals.vue?vue&type=template&id=2570f81b&scoped=true"
import script from "./DocumentAdditionals.vue?vue&type=script&lang=js"
export * from "./DocumentAdditionals.vue?vue&type=script&lang=js"
import style0 from "./DocumentAdditionals.vue?vue&type=style&index=0&id=2570f81b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570f81b",
  null
  
)

export default component.exports